module.exports = __webpack_public_path__ + "static/media/service18.dbe0a417.jpg";